import { getCurrentPath } from "@faire/web/common/Path";
import isEqual from "lodash/isEqual";
import qs, { ParsedQuery } from "query-string";

import { isAnyWhereModalPopped } from "@faire/retailer/lib/isAnyWhereModalPopped";
import { AppHistory } from "@faire/retailer/packages/core/services/AppHistory";

export abstract class FilterConsumer {
  protected previousSearchInformation?: ParsedQuery;
  protected previousSearchLocation?: string;

  abstract buildFiltersFromUrl(): void;
  abstract generateUrlFromFilters(): string;
  abstract beforeUrlUpdate(): void;

  constructor() {
    this.previousSearchInformation = qs.parse(
      AppHistory.get().history.location.search
    );
    this.previousSearchLocation = AppHistory.get().history.location.pathname;
  }

  processNewUrl = () => {
    const parsedSearch = qs.parse(AppHistory.get().history.location.search);
    const currentLocation = AppHistory.get().history.location.pathname;

    const isModal = isAnyWhereModalPopped(parsedSearch);
    const isQueryEqual = isEqual(
      qs.stringify(parsedSearch),
      this.previousSearchInformation
        ? qs.stringify(this.previousSearchInformation)
        : undefined
    );
    const isLocationEqual = isEqual(
      currentLocation,
      this.previousSearchLocation
    );

    if (!isModal && (!isQueryEqual || !isLocationEqual)) {
      this.previousSearchInformation = parsedSearch;
      this.previousSearchLocation = currentLocation;
      this.buildFiltersFromUrl();
    }
  };

  buildUrlFromFilters = () => {
    const newUrl = this.generateUrlFromFilters();

    const urlHasChanged = newUrl !== getCurrentPath().toString();

    if (!urlHasChanged) {
      return;
    }

    this.beforeUrlUpdate();

    AppHistory.get().history.push(newUrl);
  };
}
